export default "__VITE_ASSET__BUAKQehH__"